/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientOrganismAntibioticSusceptibilities } from 'app/entities/patient-organism-antibiotic-susceptibility/patient-organism-antibiotic-susceptibility.reducer';
import { getEntities as getOrganisms } from 'app/entities/organism/organism.reducer';
import { getEntities as getAntibiotics } from 'app/entities/antibiotic/antibiotic.reducer';
import { createEntity, getEntity, reset, updateEntity } from './resistance-trend.reducer';

export const ResistanceTrendUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientOrganismAntibioticSusceptibilities = useAppSelector(state => state.patientOrganismAntibioticSusceptibility.entities);
  const organisms = useAppSelector(state => state.organism.entities);
  const antibiotics = useAppSelector(state => state.antibiotic.entities);
  const resistanceTrendEntity = useAppSelector(state => state.resistanceTrend.entity);
  const loading = useAppSelector(state => state.resistanceTrend.loading);
  const updating = useAppSelector(state => state.resistanceTrend.updating);
  const updateSuccess = useAppSelector(state => state.resistanceTrend.updateSuccess);

  const handleClose = () => {
    navigate(`/resistance-trend${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientOrganismAntibioticSusceptibilities({}));
    dispatch(getOrganisms({}));
    dispatch(getAntibiotics({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.resistanceRate !== undefined && typeof values.resistanceRate !== 'number') {
      values.resistanceRate = Number(values.resistanceRate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...resistanceTrendEntity,
      ...values,
      testReference: patientOrganismAntibioticSusceptibilities.find(it => it.id.toString() === values.testReference?.toString()),
      organism: organisms.find(it => it.id.toString() === values.organism?.toString()),
      antibiotic: antibiotics.find(it => it.id.toString() === values.antibiotic?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...resistanceTrendEntity,
          testReference: resistanceTrendEntity?.testReference?.id,
          organism: resistanceTrendEntity?.organism?.id,
          antibiotic: resistanceTrendEntity?.antibiotic?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.resistanceTrend.home.createOrEditLabel" data-cy="ResistanceTrendCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.resistanceTrend.home.createOrEditLabel">Create or edit a ResistanceTrend</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="resistance-trend-id"
                  label={translate('tinyMedicRestApp.resistanceTrend.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.resistanceRate')}
                id="resistance-trend-resistanceRate"
                name="resistanceRate"
                data-cy="resistanceRate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.trendPeriod')}
                id="resistance-trend-trendPeriod"
                name="trendPeriod"
                data-cy="trendPeriod"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.notes')}
                id="resistance-trend-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.active')}
                id="resistance-trend-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.cursor')}
                id="resistance-trend-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.lastUpdated')}
                id="resistance-trend-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.microSec')}
                id="resistance-trend-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.resistanceTrend.timestampEntry')}
                id="resistance-trend-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="resistance-trend-testReference"
                name="testReference"
                data-cy="testReference"
                label={translate('tinyMedicRestApp.resistanceTrend.testReference')}
                type="select"
              >
                <option value="" key="0" />
                {patientOrganismAntibioticSusceptibilities
                  ? patientOrganismAntibioticSusceptibilities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="resistance-trend-organism"
                name="organism"
                data-cy="organism"
                label={translate('tinyMedicRestApp.resistanceTrend.organism')}
                type="select"
              >
                <option value="" key="0" />
                {organisms
                  ? organisms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="resistance-trend-antibiotic"
                name="antibiotic"
                data-cy="antibiotic"
                label={translate('tinyMedicRestApp.resistanceTrend.antibiotic')}
                type="select"
              >
                <option value="" key="0" />
                {antibiotics
                  ? antibiotics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/resistance-trend" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ResistanceTrendUpdate;
